import React, { useState }  from 'react';
import Auth from './auth';
import Marketing from './marketing';
import { default as __ } from '../../../src/utils';

const Landing = ({ defaultOpen = false }) => {
   const [showingAuth, currentSetOpen] = __.useControllableProp({
    updater: onToggle,
    defaultValue: defaultOpen,
  });

  function onToggle() { currentSetOpen(!showingAuth) };

  return showingAuth ? <Auth /> : <Marketing cb={onToggle} />
};

export default Landing;

